import { formatDateToDDMMYYYY } from 'src/app/project/shared/date-utils';

const MONTHS_IN_YEAR = 12;

export function getMonthFormattedTimeframes(startYear: number, numberOfYears: number): string[] {
  const years = Array.from({ length: numberOfYears }, (_element, index) => startYear + index);

  return years.flatMap((_year) =>
    Array.from({ length: MONTHS_IN_YEAR }, (_element, monthIndex) =>
      formatDateToDDMMYYYY(getLastDayOfMonth(_year, monthIndex)),
    ),
  );
}

function getLastDayOfMonth(year: number, monthIndex: number): Date {
  return new Date(year, monthIndex + 1, 0);
}
